/**
 * usage examples:
 * getElements('body')
 * getElements(document.querySelector('foo'))
 * getElements(document.querySelectorAll('foo'))
 *
 * always returns an array
 */
const getElements = function(selector) {
  if (typeof selector === 'string') {
    return [...document.querySelectorAll(selector)];
  }

  if (Array.isArray(selector)) {
    return selector;
  }

  return [selector];
};

export default getElements;
